var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSortArrowDownWideShortSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.143,
    height: 64,
    viewBox: "0 0 81.143 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter2511",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 -0.21 -0.72 -0.07 1.85981 0 "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.515 62.514c-0.87143 0.94286-2.0857 1.4857-3.3714 1.4857-1.2857 0-2.5-0.54286-3.3714-1.4857l-12.571-13.714c-1.7-1.8571-1.5857-4.7571 0.28571-6.4571 1.8714-1.7 4.7571-1.5857 6.4571 0.28571l4.6286 5.0429v-43.1c0-2.5286 2.0429-4.5714 4.5714-4.5714 2.5286 0 4.5714 2.0429 4.5714 4.5714v43.1l4.6286-5.0571c1.7-1.8571 4.6-1.9857 6.4571-0.28572s1.9857 4.6 0.28571 6.4571l-12.571 13.714zm24.057 1.4857c-2.5286 0-4.5714-2.0429-4.5714-4.5714 0-2.5286 2.0429-4.5714 4.5714-4.5714h4.5714c2.5286 0 4.5714 2.0429 4.5714 4.5714 0 2.5286-2.0429 4.5714-4.5714 4.5714zm0-18.286c-2.5286 0-4.5714-2.0429-4.5714-4.5714 0-2.5286 2.0429-4.5714 4.5714-4.5714h13.714c2.5286 0 4.5714 2.0429 4.5714 4.5714 0 2.5286-2.0429 4.5714-4.5714 4.5714zm0-18.286c-2.5286 0-4.5714-2.0429-4.5714-4.5714 0-2.5286 2.0429-4.5714 4.5714-4.5714h22.857c2.5286 0 4.5714 2.0429 4.5714 4.5714 0 2.5286-2.0429 4.5714-4.5714 4.5714zm0-18.286c-2.5286 0-4.5714-2.0429-4.5714-4.5714 0-2.5286 2.0429-4.5714 4.5714-4.5714h32c2.5286 0 4.5714 2.0429 4.5714 4.5714 0 2.5286-2.0429 4.5714-4.5714 4.5714z",
    filter: "url(#filter2511)",
    strokeWidth: 0.14286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSortArrowDownWideShortSolid);
export default __webpack_public_path__ + "static/media/icn-sort-arrow-down-wide-short-solid.7939087c4712617b2ac546cffd2e1410.svg";
export { ForwardRef as ReactComponent };